// Single source of truth for the Corner category checklist shown on
// the inline registration flow and the legacy /setup-corner page.
// Keep ids in sync with the backend `dj_cats` / `organiser_cats` sets
// in `routes/vendor.py::setup_corner` and `routes/auth.py::register`.

export const CORNER_CATEGORIES = [
  { id: 'street_sk8',       label: 'The Streets',      desc: 'Street sessions & jams' },
  { id: 'event_organisers', label: 'Event Organisers', desc: 'Plan & host events' },
  { id: 'merch_vendors',    label: 'Merch Vendors',    desc: 'Sell gear & apparel' },
  { id: 'trip_organisers',  label: 'Trip Organisers',  desc: 'Organise group trips' },
  { id: 'djs',              label: 'DJs',              desc: 'Spin tracks at events' },
  { id: 'for_sale',         label: 'For Sale',         desc: 'Sell or trade equipment' },
  { id: 'sk8_conversions',  label: 'Customisations',   desc: 'Custom builds & mods' },
  { id: 'teacher',          label: 'Teacher',          desc: 'Teach skills & classes' },
  { id: 'skate_og',         label: 'OG Rider',         desc: 'Veteran of the scene' },
];

// Map a registration role flag to the default Corner category it implies.
// Used by RegisterPage to pre-tick a sensible category when the user picks
// a role so they aren't faced with a blank checklist.
export const DEFAULT_CATEGORY_FOR_ROLE = {
  isEventOrganiser: 'event_organisers',
  isDJ:             'djs',
  isMerchSeller:    'merch_vendors',
};
